import { PageSource, PageSourceType } from '../../adapters/segment/constants'
import {
  PAGE_SOURCE_FROM_PATH,
  isCertificatesPage,
  isCertificateOverviewPage,
  isCertificatesPaintedDoorPage,
  isChapterPage,
  isClassPage,
  isEpisodePage,
  isSeriesPage,
  isSessionsClassPage,
  isSessionsHomePage,
  isArticlePage,
  isCategoryPage,
  isProjectsPage,
  isSubcategoryPage,
  isOutcomePage,
  isForBusinsessPage,
  isForBusinessAcceleratorPage,
  isForBusinessCollectivePage,
  isCheckoutPlansPage,
  isCheckoutPaymentPage,
  isEmailCorrectionResultsPage,
  isRecipientGuestPassPage,
  isPartnershipFreeTrialPage,
  isLoginPage,
  isCertificateLessonCurriculumPage,
  isCertificateHomepagePage,
  isHelpCenterPage,
} from './utils'

export type PrePaywallPageSource = PageSourceType | 'other' | undefined

export const getPageSource = (): PrePaywallPageSource => {
  if (typeof window === 'undefined') {
    return undefined
  }
  return inferPageSource(window.location?.pathname)
}

export const inferPageSource = (
  pathname: string | undefined,
): PrePaywallPageSource => {
  if (!pathname) {
    return undefined
  }

  // Strip query parameters before lookup
  const pathnameWithoutQuery = pathname.split('?')[0] ?? pathname

  if (isChapterPage(pathnameWithoutQuery)) {
    return PageSource.LESSON
  }

  if (isClassPage(pathnameWithoutQuery)) {
    return PageSource.CLASS_PAGE
  }

  if (isCheckoutPlansPage(pathnameWithoutQuery)) {
    return PageSource.PLANS
  }

  if (isCheckoutPaymentPage(pathnameWithoutQuery)) {
    return PageSource.CHECKOUT_PAYMENT
  }

  if (isEmailCorrectionResultsPage(pathnameWithoutQuery)) {
    return PageSource.EMAIL_CORRECTION_RESULTS
  }

  if (isEpisodePage(pathnameWithoutQuery)) {
    return PageSource.EPISODE_PAGE
  }

  if (isSeriesPage(pathnameWithoutQuery)) {
    return PageSource.SERIES_PAGE
  }

  if (isSessionsClassPage(pathnameWithoutQuery)) {
    return PageSource.SESSIONS_CLASS
  }

  if (isSessionsHomePage(pathnameWithoutQuery)) {
    return PageSource.SESSIONS_HOME
  }

  if (isArticlePage(pathnameWithoutQuery)) {
    return PageSource.ARTICLE
  }

  if (isCategoryPage(pathnameWithoutQuery)) {
    return PageSource.CATEGORY
  }

  if (isProjectsPage(pathnameWithoutQuery)) {
    return PageSource.PROJECTS
  }

  if (isSubcategoryPage(pathnameWithoutQuery)) {
    return PageSource.SUBCATEGORY
  }

  if (isOutcomePage(pathnameWithoutQuery)) {
    return PageSource.OUTCOME
  }

  if (isForBusinessAcceleratorPage(pathnameWithoutQuery)) {
    return PageSource.MAW_ACCELERATOR
  }

  if (isForBusinessCollectivePage(pathnameWithoutQuery)) {
    return PageSource.MAW_COLLECTIVE
  }

  if (isForBusinsessPage(pathnameWithoutQuery)) {
    return PageSource.MAW_HOME
  }

  if (isHelpCenterPage(pathnameWithoutQuery)) {
    return PageSource.HELP_CENTER
  }

  // The order we check for certificates pages is important

  if (isCertificateLessonCurriculumPage(pathnameWithoutQuery)) {
    return PageSource.CERTIFICATE_CURRICULUM
  }

  if (isCertificateHomepagePage(pathnameWithoutQuery)) {
    return PageSource.CERTIFICATES
  }

  // Certificates Painted Door experiment: must be checked before isCertificateOverviewPage
  // since painted door slugs would otherwise match as overview pages.

  // TODO: Clean when exp is finished - https://masterclass-dev.atlassian.net/browse/MCCERTS-1495
  if (isCertificatesPaintedDoorPage(pathnameWithoutQuery)) {
    return PageSource.CERTIFICATE_TOPIC
  }

  if (isCertificateOverviewPage(pathnameWithoutQuery)) {
    return PageSource.CERTIFICATE_OVERVIEW
  }

  if (isCertificatesPage(pathnameWithoutQuery)) {
    return PageSource.CERTIFICATES
  }

  if (isRecipientGuestPassPage(pathnameWithoutQuery)) {
    return PageSource.RECIPIENT_GUEST_PASS
  }

  if (isPartnershipFreeTrialPage(pathnameWithoutQuery)) {
    return PageSource.PARTNERSHIP_FREE_TRIAL
  }

  if (isLoginPage(pathnameWithoutQuery)) {
    return PageSource.LOG_IN
  }

  return PAGE_SOURCE_FROM_PATH[pathnameWithoutQuery] || 'other'
}
